module.exports = __webpack_public_path__ + "img/birthday.bd33a71a.png";